var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-container"},[_c('Banner'),_c('Shop'),_c('Case'),_c('Service')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }